import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-300" data-mp="3fy2ytulpdq2z">
      <SectionHeading eyebrow="What therapists are saying" title={<>
            Clearer Reasoning, <em className="text-brand" data-id="element-302" data-mp="3700rkxbdm179">Case After Case</em>
          </>} data-id="element-301" data-mp="3b0ui7yg7du3u" />

      <div className="mx-auto mt-10 grid max-w-5xl grid-cols-1 gap-5 md:grid-cols-2" data-id="element-303" data-mp="31zcze8bevebg">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-cream p-6 sm:p-7" data-id="element-304" data-mp="2x1kywpwpajvn">
            <div className="flex gap-0.5 text-amber-500" aria-label="5 out of 5 stars" data-id="element-305" data-mp="2s2rvjqb4o997">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-306" data-mp="v72gzjzdp0k8" data-mpi={i} />)}
            </div>
            <blockquote className="mt-4 flex-1 text-[17px] leading-relaxed text-ink" data-id="element-307" data-mp="h67xw01xbg89">“{t.quote}”</blockquote>
            <figcaption className="mt-6 flex items-center gap-4" data-id="element-308" data-mp="m5kmoqccuxdh">
              <img src={t.photo} alt={t.name} loading="lazy" className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-white" data-id="element-309" data-mp="m2onkyoru2ng" />
              <div data-id="element-310" data-mp="c623ic49rfmh">
                <p className="text-[16px] font-bold text-ink" data-id="element-311" data-mp="c7mz852bl4lx">{t.name}</p>
                <p className="text-[14px] text-muted" data-id="element-312" data-mp="zw65kf1t77bd">{t.role}</p>
              </div>
            </figcaption>
          </figure>)}
      </div>

      <CTAButton className="mt-12" label="I want to organize my cases like this" data-id="element-313" data-mp="14xlre9bt9hut" />
    </section>;
}